import React, { useEffect, useState, useRef } from 'react';
import { scanProducts, getRandomProduct, ScannedProduct } from '../lib/productScanner';
const SPANISH_NAMES = ['María', 'Carmen', 'Ana', 'Isabel', 'Laura', 'Cristina', 'Marta', 'Lucía', 'Elena', 'Paula', 'Antonio', 'Manuel', 'José', 'Francisco', 'David', 'Juan', 'Javier', 'Daniel', 'Carlos', 'Alejandro', 'Sofía', 'Alba', 'Julia', 'Sara', 'Rosa', 'Teresa', 'Beatriz', 'Nuria', 'Silvia', 'Irene'];
const MEXICAN_CITIES = ['Ciudad de México', 'Guadalajara', 'Monterrey', 'Puebla', 'Querétaro', 'Tijuana', 'León', 'Mérida', 'Cancún', 'Toluca', 'Chihuahua', 'Aguascalientes', 'Saltillo', 'Hermosillo', 'Mexicali', 'Culiacán', 'San Luis Potosí', 'Morelia', 'Veracruz', 'Torreón', 'Tuxtla Gutiérrez', 'Xalapa', 'Cuernavaca', 'Oaxaca'];
interface ToastData {
  id: number;
  name: string;
  city: string;
  product: ScannedProduct;
  timeAgo: string;
}
const getRandomTimeAgo = (): string => {
  // Random duration from a few seconds up to 9 minutes
  const totalSeconds = Math.floor(Math.random() * (9 * 60 - 5 + 1)) + 5;
  if (totalSeconds < 60) {
    return totalSeconds <= 20 ? 'hace pocos segundos' : `hace ${totalSeconds} segundos`;
  }
  const minutes = Math.floor(totalSeconds / 60);
  return minutes === 1 ? 'hace 1 minuto' : `hace ${minutes} minutos`;
};
export function RecentPurchaseToast() {
  const [toast, setToast] = useState<ToastData | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [catalog, setCatalog] = useState<ScannedProduct[]>([]);
  const hasTriggeredRef = useRef(false);
  const recentNamesRef = useRef<string[]>([]);
  const toastIdCounter = useRef(0);
  const timeoutRef = useRef<NodeJS.Timeout>();
  // Initialize catalog on mount
  useEffect(() => {
    setCatalog(scanProducts());
  }, []);
  const getRandomName = () => {
    const availableNames = SPANISH_NAMES.filter(n => !recentNamesRef.current.includes(n));
    const nameList = availableNames.length > 0 ? availableNames : SPANISH_NAMES;
    const name = nameList[Math.floor(Math.random() * nameList.length)];
    recentNamesRef.current.push(name);
    if (recentNamesRef.current.length > 10) {
      recentNamesRef.current.shift();
    }
    return name;
  };
  const getRandomCity = () => MEXICAN_CITIES[Math.floor(Math.random() * MEXICAN_CITIES.length)];
  const showNextToast = () => {
    const newToast: ToastData = {
      id: toastIdCounter.current++,
      name: getRandomName(),
      city: getRandomCity(),
      product: getRandomProduct(catalog.length > 0 ? catalog : undefined),
      timeAgo: getRandomTimeAgo()
    };
    setToast(newToast);
    setIsVisible(true);
    // Hide after 4-5 seconds
    const displayTime = Math.floor(Math.random() * 1000) + 4000;
    timeoutRef.current = setTimeout(() => {
      setIsVisible(false);
      // Schedule next toast after 8-15 seconds
      const nextDelay = Math.floor(Math.random() * 7000) + 8000;
      timeoutRef.current = setTimeout(showNextToast, nextDelay);
    }, displayTime);
  };
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      const [entry] = entries;
      if (entry.isIntersecting && !hasTriggeredRef.current) {
        hasTriggeredRef.current = true;
        // Initial delay of 3 seconds
        timeoutRef.current = setTimeout(showNextToast, 3000);
      }
    }, {
      threshold: 0.1
    });
    const offerSection = document.getElementById('offer-section');
    if (offerSection) {
      observer.observe(offerSection);
    }
    return () => {
      observer.disconnect();
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [catalog]); // Re-bind if catalog changes, though it shouldn't matter much
  if (!toast) return null;
  return <div className={`fixed bottom-4 left-1/2 -translate-x-1/2 sm:left-auto sm:right-6 sm:translate-x-0 z-50 transition-all duration-500 ease-out w-[90vw] sm:w-80 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0 pointer-events-none'} motion-reduce:transition-none`} data-id="element-465">
      <div className="bg-white rounded-xl shadow-2xl border border-forest/10 p-3 flex items-center gap-3" data-id="element-466">
        {toast.product.thumbnailUrl && <div className="w-12 h-12 rounded-lg bg-cream-dark shrink-0 overflow-hidden border border-gold/20 flex items-center justify-center" data-id="element-467">
            <img src={toast.product.thumbnailUrl} alt={toast.product.title} className="w-full h-full object-cover" data-id="element-468" />
          </div>}
        <div className="flex-1 min-w-0" data-id="element-469">
          <p className="text-xs text-dark/60 mb-0.5" data-id="element-470">
            <span className="font-bold text-dark" data-id="element-471">{toast.name}</span> de{' '}
            {toast.city} acaba de comprar:
          </p>
          <p className="text-sm font-bold text-forest leading-tight" data-id="element-472">
            {toast.product.title}{' '}
            {toast.product.editionLabel && `- ${toast.product.editionLabel}`}
          </p>
          <p className="flex items-center gap-1.5 text-[11px] text-dark/40 mt-1" data-id="element-473">
            <span className="w-1.5 h-1.5 rounded-full bg-success shrink-0" data-id="element-474"></span>
            {toast.timeAgo}
          </p>
        </div>
      </div>
    </div>;
}